import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import { env } from '@ivy/fts/envInfo/envInfo';
let CouponListPopup = class CouponListPopup extends Vue {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.coupons = [];
        this.vipCoupons = [];
        this.curType = 'all'; // 当前选中的优惠券类型
        this.payForList = [];
        this.compensateState = {
            0: '待审批',
            5: '赔付成功',
            10: '赔付失败',
            15: '赔付关闭',
            20: '审批拒绝',
        };
    }
    get popupVisible() {
        return true;
    }
    async created() {
        await env.init();
        this.payForList = this.info;
    }
    hide() {
        this.close({});
    }
};
tslib_1.__decorate([
    Prop()
], CouponListPopup.prototype, "close", void 0);
tslib_1.__decorate([
    Prop()
], CouponListPopup.prototype, "info", void 0);
tslib_1.__decorate([
    Prop()
], CouponListPopup.prototype, "visible", void 0);
CouponListPopup = tslib_1.__decorate([
    Component({})
], CouponListPopup);
export default CouponListPopup;
